import { useLanguage } from "@/context/LanguageContext";
import { Link, useLocation } from "react-router-dom";

export function LanguageSwitcher({ className = "" }) {
  const { locale, setLanguage, localizePath } = useLanguage();
  const location = useLocation();
  return (
    <div
      role="group"
      aria-label={locale === "hi" ? "भाषा चुनें" : "Choose language"}
      className={`inline-flex shrink-0 rounded-full border border-slate-600 p-0.5 ${className}`}
    >
      {[
        { value: "en", label: "English" },
        { value: "hi", label: "हिन्दी" },
      ].map((language) => (
        <Link
          key={language.value}
          to={{ pathname: localizePath(location.pathname, language.value), search: location.search, hash: location.hash }}
          state={location.state}
          preventScrollReset
          hrefLang={language.value}
          lang={language.value}
          aria-label={language.label}
          aria-current={locale === language.value ? "page" : undefined}
          onClick={(event) => {
            // Keep the current form state on ordinary clicks. Modified clicks
            // retain native link behavior, including opening another tab.
            if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            setLanguage(language.value);
          }}
          data-testid={`language-${language.value}`}
          className={`min-h-10 rounded-full px-3 py-2 text-sm font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-400 ${
            locale === language.value ? "bg-amber-400 text-slate-950" : "text-slate-100 hover:bg-slate-800"
          }`}
        >
          {language.label}
        </Link>
      ))}
    </div>
  );
}
